<template>
  <div class="position-relative w-100" :style="{ zIndex: isFocus ? 1000 : 1 }">
    <button
      type="button"
      class="custom-btn-secondary w-100 d-flex justify-content-between align-items-center text-small"
      :disabled="isDisabled"
      @click="toggleDropdown"
      @blur="onBlur"
    >
      <span class="text-truncate pr-2">{{ displayText }}</span>
      <v-icon :name="isFocus ? 'buttons/collapse_chevrons_down' : 'buttons/collapse_chevrons_right'" :size="10"/>
    </button>

    <div v-if="isFocus" class="custom-dropdown-select position-absolute w-100 mt-1" :class="{ 'drop-up': dropUp }">
      <div class="custom-dropdown-list-scroll">
        <div
          v-for="item in normalizedOptions"
          :key="item.value"
          class="custom-dropdown-select-item"
          @mousedown.prevent="checkItem(item.value)"
        >
          <b-form-checkbox
            :checked="value.includes(item.value)"
            class="text-small m-0"
            style="pointer-events: none;"
          >
            {{ item.text }}
          </b-form-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseMultiSelect",
  props: {
    value: { type: Array, default: () => [] },
    options: { type: Array, required: true },
    isDisabled: { type: Boolean, default: false },
    dropUp: { type: Boolean, default: false },
    placeholder: { type: String, default: 'Выбрать' }
  },
  data() {
    return {
      isFocus: false,
    };
  },
  computed: {
    normalizedOptions() {
      return this.options.map(opt => ({
        value: opt.value !== undefined ? opt.value : opt.id,
        text: opt.text !== undefined ? opt.text : opt.name
      }));
    },
    displayText() {
      if (!this.value || this.value.length === 0) return this.placeholder;

      const selectedTexts = this.normalizedOptions
        .filter(opt => this.value.includes(opt.value))
        .map(opt => opt.text);

      if (selectedTexts.length === 0) return this.placeholder;
      if (selectedTexts.length <= 2) return selectedTexts.join(", ");
      return `Выбрано: ${selectedTexts.length}`;
    }
  },
  methods: {
    toggleDropdown() {
      this.isFocus = !this.isFocus;
    },
    onBlur() {
      this.isFocus = false;
    },
    checkItem(itemValue) {
      const newValue = [...this.value];
      const index = newValue.indexOf(itemValue);

      if (index > -1) {
        newValue.splice(index, 1);
      } else {
        newValue.push(itemValue);
      }

      this.$emit('input', newValue);
    }
  }
};
</script>

<style scoped>
.custom-dropdown-select-item b-form-checkbox {
  pointer-events: none;
}
.custom-dropdown-select.drop-up {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 5px;
}
.custom-btn-secondary:focus {
  outline: none;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/utilites/commonUi/BaseMultiSelect.vue